import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileDownload, faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Link, ListItem, Text,
} from '@domain-group/suit-theme'

import useAttachment from '@hooks/useAttachment'
import useAttachments from '@hooks/useAttachments'
import useContract from '@hooks/useContract'

const confirmDelete = (deleteContract, deleteFn) => {
  const deleteContractPayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Contract Deleted',
  }

  swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, delete it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure? It cannot be recovered.',
      title: 'Delete Contract?',
    })
    .then(({ value }) => {
      if (value){
        deleteContract(deleteContractPayload)
      }
    })
}

const getColor = (expired, expiringSoon) => {
  if (expired) return 'faintGrey'
  if (expiringSoon) return 'orange'
  return 'bodyFontLightColor'
}

const ContractListItem = (props) => {
  const { callbacks, contract } = props
  const { deleteContract } = callbacks

  const {
    callbacks: {
      deleteContract: deleteFn,
    },
    contract: {
      title,
    },
    expired,
    expiringSoon,
    formattedExpiryDate,
  } = useContract(contract)

  const {
    filteredAttachments,
    hasFilteredAttachments,
  } = useAttachments({ filters: { attachable_id: contract.id, attachable_type: 'Contract' } })

  const {
    callbacks: { downloadAttachment },
  } = useAttachment(filteredAttachments[0])

  const contractExpiryStatusText = `Contract ${expired ? 'expired' : 'expiring'} on ${formattedExpiryDate}`

  return (
    <ListItem
      boxProps={{
        borderBottom: '1px dashed',
        fontSize: 'small',
        lineHeight: 1.3,
        justifyContent: 'space-between',
        padding: 'large',
      }}
      disableHover
    >
      <Box flexDirection="column" maxWidth="80%">
        <Text color="bodyFontColor" variant="ellipsis">
          {title}
        </Text>

        <Text color={getColor(expired, expiringSoon)} fontSize="xsmall" variant="ellipsis">
          {contractExpiryStatusText}
        </Text>
      </Box>

      <Box alignItems="center" justifyContent="flex-end" marginLeft="medium">
        {hasFilteredAttachments && (
          <Link greyLink onClick={e => downloadAttachment(e)} textProps={{ marginRight: 'medium' }}>
            <FontAwesomeIcon icon={faFileDownload} />
          </Link>
        )}

        <Link greyLink onClick={() => confirmDelete(deleteContract, deleteFn)}>
          <FontAwesomeIcon icon={faTrashAlt} />
        </Link>
      </Box>
    </ListItem>
  )
}

ContractListItem.propTypes = {
  callbacks: PropTypes.shape({
    deleteContract: PropTypes.func.isRequired,
  }),
  contract: PropTypes.object.isRequired,
}

export default ContractListItem
